export default __webpack_public_path__ + "static/media/spyder.08c6abf3.png";